//  订单来源 一级类目
import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface IPrimaryCategoriesProps {
  width?: number;
  value?: any;
  // 获取主类目数据
  getPrimaryCategories?: any;
  // 获取二级类目数据
  getSecondCategories?: any;
  resetSecondCategories?: any;
  share?: any;
  modelName?: any;
  "data-field"?: any;
  "secondCategories-field"?: any;
  setValue?: any;
  onChange?: any;
}

class PrimaryCategories extends React.Component<IPrimaryCategoriesProps, any> {
  constructor(props: IPrimaryCategoriesProps) {
    super(props);
  }

  componentDidMount() {
    this.props.getPrimaryCategories();
  }

  // 更改一级类目选择项时触发
  // e:更改后的值
  onChangePrimaryCategories = e => {
    // 重置订单来源二级类目数据集
    this.props.resetSecondCategories();
    // 重置二级类目选择项
    let data = { model: this.props.modelName, formInfo: {} };
    data.formInfo[this.props["secondCategories-field"]] = "";
    this.props.setValue(data);

    // 只有在主分类有值时才初始化、
    if (e) {
      // 初始化订单来源二级类目数据
      this.props.getSecondCategories(e);
    }

    // 提供在更改订单来源主分类时触发其它功能的钩子函数
    // e:更改的值 field:主分类字段
    this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.primaryCategories;
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        );
      }
      return options;
    };
    // 当数据已加载完成时才设置选中的值,这样处理可以避免由于数据集为加载而造成的闪烁
    const value = this.props.share.primaryCategories.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        value={value}
        allowClear={true}
        placeholder="选择订单来源"
        onChange={this.onChangePrimaryCategories}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getPrimaryCategories: dispatch.orderSource.getPrimaryCategories,
    getSecondCategories: dispatch.orderSource.getSecondCategories,
    // 重置二级类目数据
    resetSecondCategories: dispatch.share.resetSecondCategories,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(PrimaryCategories);
